// extracted by mini-css-extract-plugin
export default {"columnSortContainer":"column-sort-container__column-sort-container__D2Rme"};